import { truktApi } from '@api';
import { QUERY_CACHE_IDS_MAP } from '@types';
import { useQuery } from '@tanstack/react-query';

export const useBranchOptionsQuery = (q: string) => {
  const search = q.trim();
  const queryKey = [QUERY_CACHE_IDS_MAP.BRANCH, search.toLowerCase()];
  const query = useQuery({
    queryKey: queryKey,

    queryFn: async () => {
      const request = {
        queryParams: { search: search || undefined },
      };
      const data = await truktApi.client.searchBranches(request);

      return data;
    },
  });

  return query;
};
